// function for setting cell color based on percentage //
import React from "react"
import tinycolor from 'tinycolor2'
import ordinalSuffix from "../../../../utilities/ordinalSuffix"

const Rank32 = ({ val, order }) => {

    var parsedVal = parseInt(val)

    if (order === 'asc') {
        parsedVal = 1 - (parsedVal -1) / 31
    } else {
        parsedVal = (parsedVal -1) / 31
    }

    const c6n = '#c4d8ff'
    const c4n = '#d1d2ff'
    const c2n = '#e2dbff'
    const c0 = '#ffffff'
    const c2p = '#ffdbf8'
    const c4p = '#ffe1cf'
    const c6p = '#fffbd9'

    // background //
    var calcedBackground = tinycolor('#ffffff')
    if (isNaN(parsedVal)) {
        calcedBackground = tinycolor('#ffffff')
    } else if (parsedVal <= .05) {
        calcedBackground = tinycolor(c6n)
        calcedBackground.setAlpha(.75 - (.25*((parsedVal) / .05 )))
    } else if (parsedVal <= .20) {
        calcedBackground = tinycolor(tinycolor.mix(c6n, c4n, 100 * (parsedVal - .05) / .15 ))
        calcedBackground.setAlpha(.50 - (.25*((parsedVal - .05) / .15 )))
    } else if (parsedVal <= .35) {
        calcedBackground = tinycolor(tinycolor.mix(c4n, c2n, 100 * (parsedVal - .2) / .15))
        calcedBackground.setAlpha(.25)
    }  else if (parsedVal <= .5) {
        calcedBackground = tinycolor(tinycolor.mix(c2n, c0, 100 * (parsedVal - .35) / .15))
        calcedBackground.setAlpha(.25)
    } else if (parsedVal <= .65) {
        calcedBackground = tinycolor(tinycolor.mix(c0, c2p, 100 * (parsedVal - .5) / .15))
        calcedBackground.setAlpha(.25)
    } else if (parsedVal <= .80) {
        calcedBackground = tinycolor(tinycolor.mix(c2p, c4p, 100 * (parsedVal - .65) / .15))
        calcedBackground.setAlpha(.25 + (.25*((parsedVal - .65) / .15 )))
    } else {
        calcedBackground = tinycolor(tinycolor.mix(c4p, c6p, 100 * (parsedVal - .8) / .15))
        calcedBackground.setAlpha(.50 + (.25*((parsedVal - .8) / .15 )))
    }

    return (
        <div style={{
            background : calcedBackground.toString(),
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {isNaN(parsedVal) ? '--' : ordinalSuffix(val)}
        </div>
    )
    
}

export default Rank32